// Package imports:
import React from 'react';
import HeadSection from '../../ui-elements/HeadSection/HeadSection';
import Instructions from './Instructions';
import Alert from '../../ui-elements/Alert/Alert';
import Link from '../../ui-elements/Link/Link';
// Component imports:

const NoAccessPage: React.FC = () => {
    return (
        <div className="KCL_due_diligence_no_access_page">
            <div className="section--white">
                <div className="shell">
                    <HeadSection title="Áreiðanleikakannanir (KYC)" />
                </div>

                <div className="shell">
                    <div className="layout">
                        {/* instructions area */}
                        <Instructions
                            isIndividual={false}
                            noAccess={true}
                        />

                        <Alert
                            type="info"
                            headText="Þú hefur ekki aðgang að þessari þjónustu."
                            text={<>
                                Til að fá aðgang að áreiðanleikakönnunum (KYC) þarftu að hafa samband við söluteymi okkar. <Link url='/Areidanleikakannanir#kynning'>Smelltu hér fyrir nánari upplýsingar.</Link>
                            </>}
                        />
                    </div>
                </div >
            </div>
        </div>
    );
}

export default NoAccessPage;